import { createSlice } from "@reduxjs/toolkit";
import { StoreState } from "../types/index.js";

const store = createSlice({
  name: "store",
  initialState: {} as StoreState,
  reducers: {
    /**
     * Reset the store, but leave the properties which wouldn’t change on a revision revert
     */
    resetStore: (state) => state,
  },
});

export const { resetStore } = store.actions;

export default store.reducer;
